module.exports = __webpack_public_path__ + "static/media/header-bg.c9930c21.jpg";